import {
  BreederContractsActionTypes,
  BreederContractsState,
} from 'store/breederContracts/types';

const initialState: BreederContractsState = {
  loading: false,
  data: [],
  error: null,
};

export default function breederContractsReducer(
  state = initialState,
  action: BreederContractsActionTypes
): BreederContractsState {
  switch (action.type) {
    case 'SET_BREEDER_CONTRACT_LOADING': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'FETCH_BREEDER_CONTRACT': {
      const { data } = action;
      return {
        ...state,
        loading: false,
        data,
      };
    }
    default:
      return state;
  }
}
